module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title"
    }],
    staticClass: "body-container",
    attrs: {
      "id": "register",
      "data-title": _vm.$t('titleText.create_account')
    }
  }, [_c('basicheader', {
    attrs: {
      "login": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t("register.register")))])]), _vm._v(" "), _c('div', {
    staticClass: "register-wapper"
  }, [_c('div', {
    staticClass: "register-head"
  }, [_c('router-link', {
    staticClass: "register-tab",
    attrs: {
      "to": "/phone",
      "active-class": "active"
    }
  }, [_c('span', {
    staticClass: "tab-item"
  }, [_vm._v(_vm._s(_vm.$t("register.phone_register")))])]), _vm._v(" "), _c('router-link', {
    staticClass: "register-tab email-tab",
    attrs: {
      "to": "/email",
      "active-class": "active"
    }
  }, [_c('span', {
    staticClass: "tab-item last"
  }, [_vm._v(_vm._s(_vm.$t("register.email_register")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('router-view', {
    attrs: {
      "lang": _vm.lang
    }
  })], 1)])])]), _vm._v(" "), _c('czurfooter', {
    on: {
      "changeAppLocale": _vm.changeAppLocale
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30ffdffa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ffdffa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/register/register.vue
// module id = 419
// module chunks = 3